<script setup lang="ts" generic="Value">
import { useField } from 'vee-validate';
import { toRef } from 'vue';
import { SelectItemTypeObject, VeeAutocompleteProps } from '../types';
import Autocomplete from './Autocomplete.vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeAutocompleteProps<Value>>();

const veeProps = useVeeFormProps(props);

defineSlots<{
  itemTitle?(props: SelectItemTypeObject<Value>): any;
}>();

const { errorMessage, value, handleChange, handleBlur, meta } = useField<Value | Value[]>(
  toRef(() => props.name),
  undefined,
  { validateOnValueUpdate: false },
);

function onUpdate(input: Value | Value[]) {
  handleChange(input, meta.touched);
}

function onBlur(event: FocusEvent) {
  handleBlur(event, true);
}
</script>

<template>
  <Autocomplete
    v-bind="veeProps"
    :modelValue="value"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  >
    <template v-for="(_, name) in $slots as {}" #[name]="slotData">
      <slot :name="name" v-bind="slotData as any" />
    </template>
  </Autocomplete>
</template>
